(() => {
  const init = (root) => {
    if (!root || root.dataset.hvReady) return;
    root.dataset.hvReady = 'true';
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const activate = (tab) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = root.querySelector('#' + item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); activate(tabs[next]); tabs[next].focus();
      });
    });
    const form = root.querySelector('.hv-finder__form');
    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const values = new FormData(form);
      const portable = values.get('priority') === 'portable';
      const business = values.get('setting') === 'business';
      root.querySelector('[data-hv-result-title]').textContent = portable ? 'P20S — compact, with sound.' : 'P30S — a larger visual stage.';
      root.querySelector('[data-hv-result-copy]').textContent = portable
        ? 'You put compact size, battery and sound first. The P20S catalog configuration combines those features with an 18.5 cm display.' + (business ? ' For your business setup, confirm battery runtime and safe placement with us.' : ' A smaller format for your desk or creative corner; confirm the hardware revision before ordering.')
        : 'You put visual scale and LED detail first. P30S offers a 28 cm open-frame display and 384 RGB LEDs.' + (business ? ' A strong fit for a stable indoor counter or event display with a clear rotating area.' : ' Give it a stable surface and enough clear space around the exposed rotating arm.');
      const link = root.querySelector('[data-hv-result-link]');
      link.href = portable ? '/products/p20s-battery-speaker-holographic-display' : '/products/p30s-open-frame-desktop-holographic-display';
      link.textContent = portable ? 'Explore P20S ↗' : 'Explore P30S ↗';
      form.querySelector('.hv-finder__result').hidden = false;
    });
  };
  document.querySelectorAll('[data-hv-home]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-hv-home]')));
})();
